import React from "react"
import { useEffect, useCallback, useContext } from 'react'
import { Navigate } from 'react-router-dom'
import LoadingScreen from 'app/components/LoadingScreen'
import useDodoableQuery from 'generated/api/dodoables/useDodoableQuery'
import HeaderContext from 'app/HeaderContext'
import StartNewButton from 'app/dodones/shared/StartNewButton'

export default ({ dodoableId }) => {
  const { setText } = useContext(HeaderContext)
  const { isPending, data: { dodoable } = {} } = useDodoableQuery({ dodoableId })

  useEffect(() => {
    setText(dodoable?.name || 'Loading...')

    if(!dodoable) return
  }, [dodoable])

  if(isPending) return <LoadingScreen />
  if(!isPending && !dodoable) return <Navigate to={ `/` } replace />

  return <div className="p-2 m-2 fcol flex-1 justify-center">
           <StartNewButton dodoableId = { dodoableId } />
         </div>;
};
